import { Remote } from "comlink";
import { GetState, SetState } from "zustand";
import { BetStore } from "..";
import isServer from "../../../libs/is-server";
import { Bet } from "../../../types/bet";
import { IDBBetHandler } from "../../../workers/idb-bet-storer";
import { IDBBetSyncHandler } from "../../../workers/idb-bet-sync-handler";
import useAppStore, { ReductionRequirementView } from "../../app-store";
import uploadBet from "../upload-bet";

export const removeFactorReduction = async (
  set: SetState<BetStore>,
  get: GetState<BetStore>,
  idbBetWorkerApi?: Remote<IDBBetHandler>,
  idbBetSyncWorkerApi?: Remote<IDBBetSyncHandler>
): Promise<void> => {
  const { bet } = get();

  const { currentBetId, reductionRequirementView } = useAppStore.getState();

  if (!currentBetId || !bet) {
    return;
  }

  const { reductionRequirement } = bet;

  const newBet: Bet = {
    ...bet,
    reductionRequirement: {
      ...reductionRequirement,
      factorReduction: undefined,
    },
    rows: bet.rows.map((row) => ({
      ...row,
      factorReduction: undefined,
    })),
  };

  set({
    bet: newBet,
    uploading: true,
  });

  if (reductionRequirementView === ReductionRequirementView.FACTOR) {
    useAppStore
      .getState()
      .setReductionRequirementView(ReductionRequirementView.RANK);
  }

  if (!isServer) {
    uploadBet(
      currentBetId,
      newBet,
      () => set({ uploading: false }),
      idbBetSyncWorkerApi
    );

    if (idbBetWorkerApi) idbBetWorkerApi.storeBet(currentBetId, newBet);
  }
};
